export default __webpack_public_path__ + "static/media/743.efb7401e.gif";